import { Injectable } from '@angular/core';
import { NotificationService } from 'app/00_modules/core/services/notification.service';
import { fromEvent as observableFromEvent, merge as observableMerge, Observable, of as observableOf, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class HealthService {
    private subscription: Subscription;
    private online$: Observable<boolean>;

    constructor(private notificationService: NotificationService) {
        this.online$ = observableMerge(
            observableOf(navigator.onLine),
            observableFromEvent(window, 'online').pipe(
                map(() => {
                    this.notificationService.infoTranslate('COMMON.BACK_ONLINE');
                    return true;
                })
            ),
            observableFromEvent(window, 'offline').pipe(
                map(() => {
                    this.notificationService.errorTranslate('COMMON.OFFLINE');
                    return false;
                })
            )
        );
    }

    public Start(): void {
        this.subscription = this.online$.subscribe();
    }

    public Stop(): void {
        this.subscription.unsubscribe();
    }
}
